// extracted by mini-css-extract-plugin
export var cardHeader = "_hd-0";
export var reorderHandle = "_hd-3";
export var titleArea = "_hd-1";
export var titleAreaWithHandle = "_hd-2";